import React from 'react';
import { capitalize } from '../helpers'
import swal from 'sweetalert'
import { connect } from 'react-redux';

class FiltersUpdate extends React.Component {
  // batchUpdate() {
  //   this.props.batchUpdate()
  // }
  //
  // dryBatchUpdate() {
  //   this.props.batchUpdate(true)
  // }

  operator(operation, append, column, value=null, pattern="") {
    const col = (column === "newentry") ? "New Entry" : capitalize(column)
    const operators = {
      "set": (
        <div className="col s11 filtersColumn">
          <span className="operatorColumn mr15">Set</span>
          <span className="fieldColumn mr15">{ col }</span>
          <span className="operatorColumn mr15">to</span>
          <span className="valueColumn">{value}</span>
        </div>
      ),
      "clear": (
        <div className="col s11 filtersColumn">
          <span className="operatorColumn mr15">Clear column</span>
          <span className="fieldColumn mr15">{ col }</span>
        </div>
      ),
      "replace": (
        <div className="col s11 filtersColumn">
          <span className="fieldColumn mr15">In { col }</span>
          <span className="operatorColumn mr15">Replace pattern</span>
          <span className="valueColumn mr15">{pattern}</span>
          <span className="operatorColumn mr15">with</span>
          <span className="valueColumn mr15">{value}</span>
        </div>
      ),
      "append": (
        <div className="col s11 filtersColumn">
          <span className="valueColumn mr15">{value}</span>
          <span className="operatorColumn mr15">will be appended to</span>
          <span className="fieldColumn mr15">{ col }</span>
        </div>
      ),
      "prepend": (
        <div className="col s11 filtersColumn">
        <span className="valueColumn mr15">{value}</span>
        <span className="operatorColumn mr15">will be prepended to</span>
        <span className="fieldColumn mr15">{ col }</span>
        </div>
      ),
      "append_field": (
        <div className="col s11 filtersColumn">
          <span className="fieldColumn mr15">Value of {capitalize(append)}</span>
          <span className="operatorColumn mr15">will be appended to</span>
          <span className="fieldColumn mr15">{ col }</span>
        </div>
      ),
      "prepend_field": (
        <div className="col s11 filtersColumn">
          <span className="fieldColumn mr15">Value of {capitalize(append)}</span>
          <span className="operatorColumn mr15">will be prepended to</span>
          <span className="fieldColumn mr15">{ col }</span>
        </div>
      ),
      "revert_row": (
        <div className="col s11 filtersColumn">
          <span className="operatorColumn mr15">Revert row to its original values</span>
        </div>
      ),
      "revert_column": (
        <div className="col s11 filtersColumn">
          <span className="fieldColumn mr15">{ col }</span>
          <span className="operatorColumn mr15">will be reverted to its original value</span>
        </div>
      ),
      "revert_append": (
        <div className="col s11 filtersColumn">
          <span className="fieldColumn mr15">{ col }</span>
          <span className="operatorColumn mr15">will be reverted to its original value and</span>
          <span className="valueColumn mr15">{value}</span>
          <span className="operatorColumn mr15">will be appended to it</span>
        </div>
      ),
      "revert_prepend": (
        <div className="col s11 filtersColumn">
          <span className="fieldColumn mr15">{ col }</span>
          <span className="operatorColumn mr15">will be reverted to its original value and</span>
          <span className="valueColumn mr15">{value}</span>
          <span className="operatorColumn mr15">will be prepended to it</span>
        </div>
      ),
    }
    return operators[operation]
  }

  render() {

    const {operations, condition_id} = this.props

    if (!operations || operations.length === 0) {
      return ''
    }

    return (
      <React.Fragment>
        {
          operations.map( (currentOperation) => {
            const {key, append, field, operation, value, pattern} = currentOperation
            const fieldRow = this.operator(operation, append, field, value, pattern)

            return (
              <div className="row" key={key}>
                <div className="col s1">
                  <a href="" onClick={(e) => {
                    e.preventDefault()
                    this.props.removeOperation(condition_id, key)
                  }}>
                    <i className="material-icons c-red" title="Remove Filter">cancel</i>
                  </a>
                </div>
                { fieldRow }
              </div>
            )
          }
        )
      }

      </React.Fragment>
    )
  }
}

export default FiltersUpdate



// WEBPACK FOOTER //
// ./src/js/components/FiltersUpdate.js